<!-- <div class="login-bg">
    <div class="row justify-content-md-center">
        <div class="col"></div>
        <div class="col">
            <div class="login-container">
                <div class="rectangle">
                <img src="images/logo.png" class="logo-img">


                </div>
            </div>
        </div>
        <div class="col"></div>
    </div>
</div> -->


<div class="row h-100">
    <div class="col-lg-8 d-none d-lg-block">
        <div id="auth-right"></div>
    </div>
    <div class="col-lg-4 col-12">
        <div id="auth-left">
            <div class="auth-logo">
                <img src="/images/logo.png" alt="Logo">
            </div>
            <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                <div>
                    <label class="form-label">Usuario</label>

                    <input class="form-control" type="email" id="username" formControlName="username" />

                    @if (f.username.errors && f.username.hasError('required') && submitted) {
                    <p class="help is-danger">El usuario es requerido</p>
                    }
                </div>
                <div class="mt-3">
                    <label class="form-label">Contraseña</label>

                    <input type="Password" class="form-control" id="password" formControlName="password" />

                    @if (f.password.errors && f.password.hasError('required') && submitted) {
                    <p class="help is-danger">Contraseña es requerida</p>
                    }
                </div>

                <div class="mt-4">
                    <div class="d-grid gap-2">
                        @if (!loading) {
                        <button type="submit" class="btn btn-primary">Iniciar sesión</button>
                        }
                        @if (loading) {
                        <button type="button" class="btn btn-primary is-loading" disabled>
                            Validando
                            <span class="material-symbols-outlined loading-icon">
                                progress_activity
                            </span>
                        </button>
                        }
                    </div>
                </div>
            </form>
        </div>
    </div>

</div>